var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/partials/account-navigation-h2-medium.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<h2 class=\"o-secondary-navigation__h2 u-extra-small--hide u-medium--show\" data-qa-account-h2-nav>\n    <a class=\"o-secondary-navigation__a o-secondary-navigation__a--parent-category ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "dashboard")?"o-secondary-navigation__a--current":""), env.opts.autoescape);
output += "\" href=\"";
output += runtime.suppressValue((lineno = 1, colno = 161, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "accountUrl"), "accountUrl", context, ["dashboard"])), env.opts.autoescape);
output += "\" data-link-name=\"dashboard\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-my-account",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n    </a>\n</h2>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/partials/account-navigation-h2-medium.j2"] , dependencies)